import { render, staticRenderFns } from "./AccountCredit.vue?vue&type=template&id=526db694&scoped=true&"
import script from "./AccountCredit.vue?vue&type=script&lang=js&"
export * from "./AccountCredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526db694",
  null
  
)

export default component.exports